module.exports = __webpack_public_path__ + "static/img/SelectTopic02.27d7065.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/SelectTopic02.png
// module id = 9TyF
// module chunks = 24